import { render, staticRenderFns } from "./PredictiveRoutingConfigDeleteModalBasic.vue?vue&type=template&id=761c2341"
import script from "./PredictiveRoutingConfigDeleteModalBasic.vue?vue&type=script&lang=js"
export * from "./PredictiveRoutingConfigDeleteModalBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports